import axiosInstance from '@/services';
import { APIS } from '@/utilities/constants';
import { LocalStorageService } from 'br2s-ui-common-utils-02';

export const AccountAPI = {
  getUserPayload: async () => {
    const { user } = LocalStorageService.getAuthInfo('user');
    // istanbul ignore next
    const params =
      user && user.profileId ? { userProfileId: user.profileId } : {};

    const response = await axiosInstance.get(APIS.GET_USER_INFO, { params });
    return response;
  },

  getUserProfile: async () => {
    const { user } = LocalStorageService.getAuthInfo('user');
    // istanbul ignore next
    const params =
      user && user.profileId ? { userProfileId: user.profileId } : {};

    const response = await axiosInstance.get(APIS.GET_USER_PROFILE, { params });
    return response;
  },

  getPHContactInfo: async () => {
    const { uen } = LocalStorageService.getAuthInfo('uen');
    const response = await axiosInstance.get(APIS.POSITION_HOLDR_INFO, {
      params: { uen },
    });
    return response;
  },

  getRQIContactInfo: async () => {
    const { user } = LocalStorageService.getAuthInfo('user');
    // istanbul ignore next
    const params =
      user && user.profileId ? { userProfileId: user.profileId } : {};

    const response = await axiosInstance.get(APIS.QI_CONTACT_INFO, { params });
    return response;
  },

  getGCContactInfo: async () => {
    const { user, uen } = LocalStorageService.getAuthInfo('user', 'uen');
    // istanbul ignore next
    const params = {
      ...(user && user.profileId ? { userProfileId: user.profileId } : {}),
      uen,
    };

    const response = await axiosInstance.get(APIS.GC_CONTACT_INFO, { params });
    return response;
  },

  getEntityInfo: async (
    key: 'uen' | 'entityName',
    value: string,
    page = 0,
    pageSize = 10,
  ) => {
    const params = { [key]: value, page, pageSize };
    const response = await axiosInstance.get(APIS.GET_ENTITY_INFO, { params });
    return response;
  },
};
